import axios from "axios";

export interface S3UploadRequestPayload {
  url: string;

  file: File | Blob;
}

export const s3Upload = async ({
  url,
  file,
}: S3UploadRequestPayload): Promise<void> => {
  const response = await axios.put(url, file, {
    headers: {
      "Content-Type": file.type,
    },
  });

  return response.data;
};
